const AccessAuthorization = "/access-authorization";
const Promos = "/promos";
const Stations = "/stations";
const Products = "/products";
const Inventory = "/inventory";
const Records = "/records";

const Path = {
  Slash: "/",
  Auth: "/auth",
  AccessAuthorization: AccessAuthorization,
  UserAccess: `${AccessAuthorization}/user-access`,
  Stations: Stations,
  AddStation: `${Stations}/add`,
  EditStation: (id, mode) => `${Stations}/details/${id}/${mode}`,
  ViewStation: (id, mode) => `${Stations}/details/${id}/${mode}`,
  StationDetails: `${Stations}/details/:id/:mode`,
  PromosList: Promos,
  AddPromo: `${Promos}/add`,
  PromoDetails: `${Promos}/details/:id/:mode`,
  Products: `${Products}`,
  AddProduct: `${Products}/add`,
  ProductDetails: `${Products}/details/:id/:mode`,
  EditProduct: (id, mode) => `${Products}/details/${id}/${mode}`,
  ViewProduct: (id, mode) => `${Products}/details/${id}/${mode}`,
  Inventory: Inventory,
  OrderSummary: `${Inventory}/order-summary`,
  OrderSummaryDetails: `${Inventory}/order-summary/details/:id/:mode`,
  ViewOrderSummaryDetails: (id, mode) => `${Inventory}/order-summary/details/${id}/${mode}`,
  Records: Records,
  ShiftRecords: `${Records}/shift-records`,
  ShiftRecordDetails: `${Records}/shift-records/details/:id/:mode`,
  ViewShiftRecordDetails: `${Records}/shift-records/details/:id/:mode`,
  viewShiftRecordDetailsUrl: (id, mode) => `${Records}/shift-records/details/${id}/${mode}`,
  DiscountReport: `${Records}/discount-report`,
  Downloads: "/downloads",
};

export default Path;
